import ih from 'immutability-helper';

import * as types from './actionTypes';
import initialState from './initialState';

interface Action {
  type:
    | typeof types.GET_FLOW_PROJECT_REQUEST
    | typeof types.GET_FLOW_PROJECT_SUCCESS
    | typeof types.GET_FLOW_PROJECT_ERROR
    | typeof types.SET_FLOW_PROJECT_LAST_SYNC_DATE;
  payload?: any;
}

const projectReducer = (state = initialState, action: Partial<Action> = {}) => {
  switch (action.type) {
    case types.GET_FLOW_PROJECT_REQUEST:
      return ih(state, {
        show: {
          isLoading: { $set: true },
        },
      });
    case types.GET_FLOW_PROJECT_SUCCESS:
      return ih(state, {
        show: { $merge: { isLoading: false, data: action.payload.data } },
      });
    case types.GET_FLOW_PROJECT_ERROR:
      return ih(state, {
        show: { $merge: { isLoading: false, error: action.payload.error } },
      });
    case types.SET_FLOW_PROJECT_LAST_SYNC_DATE:
      return ih(state, {
        show: {
          data: {
            last_nlu_sync_at: {
              $set: action.payload.last_nlu_sync_at,
            },
          },
        },
      });
    default:
      return state;
  }
};

export default projectReducer;
